import { render, staticRenderFns } from "./NavigateAwayModal.vue?vue&type=template&id=2d0f2c75"
import script from "./NavigateAwayModal.vue?vue&type=script&lang=js"
export * from "./NavigateAwayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports